import { ModuleWithProviders, NgModule } from '@angular/core';
import { HotkeysService } from './hotkeys.service';

@NgModule({})
export class HotkeyModule {
  public static forRoot(): ModuleWithProviders<HotkeyModule> {
    return {
      ngModule: HotkeyModule,
      providers: [HotkeysService],
    };
  }
}
